(function () {
  function refreshCarouselPagination(carousel) {
    if (!carousel.itemsToShow || !carousel.itemsToShow.length) return;

    var isVerticalDesktop =
      window.matchMedia('(min-width: 1025px)').matches &&
      carousel.getAttribute('data-layout') !== 'slideshow-below';

    if (isVerticalDesktop && typeof carousel.updateCarousel === 'function') {
      carousel.updateCarousel();
      return;
    }

    if (typeof carousel.horizontalUpdateCarousel === 'function') {
      carousel.horizontalUpdateCarousel();
    }
  }

  function bindThumbActiveObserver(carousel) {
    if (carousel.dataset.kikThumbPaginationBound === 'true') return;
    carousel.dataset.kikThumbPaginationBound = 'true';

    const observer = new MutationObserver(function () {
      refreshCarouselPagination(carousel);
    });

    carousel.querySelectorAll('.product-slideshow__thumb').forEach(function (thumb) {
      observer.observe(thumb, { attributes: true, attributeFilter: ['class'] });
    });

    window.setTimeout(function () {
      refreshCarouselPagination(carousel);
    }, 250);
  }

  function initProductSlideshowCarousels(root) {
    root.querySelectorAll('sht-slideshow-carousel').forEach(function (carousel) {
      bindThumbActiveObserver(carousel);
    });
  }

  function boot() {
    initProductSlideshowCarousels(document);
  }

  if (customElements && typeof customElements.whenDefined === 'function') {
    customElements.whenDefined('sht-slideshow-carousel').then(boot);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductSlideshowCarousels(event.target);
  });
})();
